<template>
    <div v-if="showCampaignSuccessPopup" class="campaign-success-overlay" @click.self="dismissCampaignSuccessPopup">
        <div class="campaign-success-popup" role="alertdialog" aria-modal="true" aria-live="assertive">
            <div class="campaign-success-icon" aria-hidden="true">✓</div>
            <h2>Campaign created successfully</h2>
            <button type="button" @click="dismissCampaignSuccessPopup">OK</button>
        </div>
    </div>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <!--Breadcrumbs and title embedded within below data page-->
            <div class="container">
                <partner-breadcrumbs />
            </div>
            <div class="tabs">

                <div class="tab-header">
                    <button class="tab-button" @click="setActiveTab('bots')" :class="{ active: activeTab === 'bots' }">AI
                        Agents</button>
                    <!-- <button class="tab-button" @click="activeTab = 'profile'"
                        :class="{ active: activeTab === 'profile' }">Profile</button> -->
                    <button v-if="showOutboundCampaignTab" class="tab-button" @click="setActiveTab('outboundCampaign')"
                        :class="{ active: activeTab === 'outboundCampaign' }">Outbound Calling</button>
                    <button v-if="customerGUID === 'AD19537023AE4333B185521BF7078F60'" class="tab-button"
                        @click="setActiveTab('contractorLists')"
                        :class="{ active: activeTab === 'contractorLists' }">Contractor Lists</button>
                </div>
                <div class="tab-content">
                    <div v-if="activeTab === 'bots'">
                        <div class="container">
                            <BotsTiles :selected-state="selectedState" />
                        </div>
                    </div>
                    <div v-if="activeTab === 'profile'">
                        <div class="container"> </div>
                    </div>
                    <div v-if="activeTab === 'outboundCampaign'">
                        <button class="title-btn" @click="navigateToAddCampaign">
                            <font-awesome-icon icon="fa-address-book" />
                            CREATE A NEW OUTBOUND CAMPAIGN
                        </button>
                        <div class="container">
                            <table class="campaign-table">
                                <thead>
                                    <tr>
                                        <th>Campaign Name</th>
                                        <th>Campaign Status</th>
                                        <th>AI Agent Name</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th class="actions-header">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="campaign in paginatedCampaigns" :key="campaign.id">
                                        <td>
                                            <router-link
                                                :to="{ path: '/partner/campaign-details', query: { campaignid: campaign.id } }"
                                                class="campaign-link">
                                                {{ campaign.name }}
                                            </router-link>
                                        </td>
                                        <td class="status-cell">
                                            <span :class="['status-dot', getStatusClass(campaign.status)]"></span>{{
                                                campaign.status }}
                                        </td>
                                        <td>{{ campaign.botName }}</td>
                                        <td>{{ formatDate(campaign.startDate) }}</td>
                                        <td>{{ formatDate(campaign.endDate) }}</td>
                                        <td class="actions-cell">
                                            <div class="action-menu-container">
                                                <button class="action-btn" @click.stop="toggleMenu(campaign.id)">
                                                    Actions▾
                                                </button>
                                                <div v-if="showMenu === campaign.id" class="action-menu">
                                                    <button @click="editCampaign(campaign.id, campaign.name)"
                                                        class="action-menu-item edit">View</button> <button
                                                        @click="deleteCampaign(campaign.id)"
                                                        :disabled="campaign.status === 'In-progress'"
                                                        class="action-menu-item delete">Delete</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                                <div class="pagination-controls mt-4">
                                    <span class="text-caption">
                                        Showing {{ Math.min((page - 1) * itemsPerPage + 1, campaigns.length) }} -
                                        {{ Math.min(page * itemsPerPage, campaigns.length) }} of {{ campaigns.length }}
                                    </span>
                                    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" density="compact"
                                        size="small" />
                                </div>
                            </div>
                    </div>
                    <div v-if="activeTab === 'contractorLists'">
                        <FleetUpdateContractorsList />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './SideBar.vue'
import BotsTiles from '../vuetify/BotsTiles.vue'
import PartnerBreadcrumbs from './PartnerBreadcrumbs.vue'
import FleetUpdateContractorsList from './FleetUpdateContractorsList.vue'

export default {
    name: 'CustomerDetails',
    components: {
        SideBar,
        BotsTiles,
        PartnerBreadcrumbs,
        FleetUpdateContractorsList
    },
    data() {
        return {
            activeTab: 'bots', // Default active tab
            page: 1,
            itemsPerPage: 10,
            campaigns: [],
            showMenu: null,
            customerGUID: null,
            selectedState: 'All',
            showCampaignSuccessPopup: false,
        }
    },
    created() {
        // Reset bot details
        localStorage.removeItem('botName');
        localStorage.removeItem('botDisplayName');
        localStorage.removeItem('botID');
        localStorage.removeItem('botType');
        localStorage.removeItem('botDID');
        localStorage.removeItem('campaignName');
        this.australianStates = [
            { value: 'All', text: 'All States' },
            { value: 'NSW', text: 'New South Wales' },
            { value: 'QLD', text: 'Queensland' },
            { value: 'VIC', text: 'Victoria' },
        ];
    },
    computed: {
        filteredCampaigns() {
            if (this.selectedState === 'All') {
                return this.campaigns;
            }
            return this.campaigns.filter(campaign =>
                campaign.botName && campaign.botName.startsWith(this.selectedState)
            );
        },
        pageCount() {
            return Math.ceil(this.filteredCampaigns.length / this.itemsPerPage);
        },
        paginatedCampaigns() {
            const start = (this.page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredCampaigns.slice(start, end);
        },
        showOutboundCampaignTab() {
            const allowedCustomerGUIDs = [
                "764514EE-B876-4E98-86F5-3339AF2C0FFA",
                "BC359469FC114747BC5B29F35CB25D0F",
                "AD19537023AE4333B185521BF7078F60",
                "8A827E4FBAAA4331AF0DC7CF0DDC1E04"

            ];

            return allowedCustomerGUIDs.includes(this.customerGUID);
        }

    },

    mounted() {
        const activeTab = this.$route.query.activeTab;
        if (activeTab) {
            this.activeTab = activeTab;
        }
        this.showCampaignSuccessPopup = this.$route.query.campaignCreated === 'true';

        this.customerGUID = (localStorage.getItem('customerGUID') || '').toUpperCase();
        if (!this.customerGUID) {
            this.$router.push('/partner/dashboard');
        } else if (!this.customerGUID) {
            this.$router.push('/partner/customers');
        } else {
            this.fetchCampaigns();
        }
        window.addEventListener('click', this.closeMenu);
    },
    beforeUnmount() {
        window.removeEventListener('click', this.closeMenu);
    },
    watch: {
        '$route.query.activeTab'(activeTab) {
            if (activeTab) {
                this.activeTab = activeTab;
            }
        },
        '$route.query.campaignCreated'(campaignCreated) {
            this.showCampaignSuccessPopup = campaignCreated === 'true';
        },
        selectedState(newState) {
            // When the selected state changes, save it to localStorage.
            localStorage.setItem('selectedState', newState);
        }
    },
    methods: {
        setActiveTab(tab) {
            this.activeTab = tab;
            this.$router.replace({
                path: '/partner/customer',
                query: { ...this.$route.query, activeTab: tab }
            });
        },
        navigateToAddCampaign() {
            if (this.customerGUID === 'AD19537023AE4333B185521BF7078F60') {
                this.$router.push({
                    path: '/partner/fleet-outbound-campaign',
                    query: { state: this.selectedState }
                });
            } else {
                this.$router.push({
                    path: '/partner/outbound-campaign',
                    query: { state: this.selectedState }
                });
            }
        },
        async fetchCampaigns() {
            if (!this.customerGUID) {
                this.$router.push('/partner/dashboard');
                return;
            }
            try {
                const allowedCustomerGUIDs = [
                    "764514EE-B876-4E98-86F5-3339AF2C0FFA",
                    "BC359469FC114747BC5B29F35CB25D0F",
                    "AD19537023AE4333B185521BF7078F60",
                    "8A827E4FBAAA4331AF0DC7CF0DDC1E04"

                ];
                if (!allowedCustomerGUIDs.includes(this.customerGUID)) {
                    this.campaigns = [];
                    return;
                }
                const baseUrl = process.env.VUE_APP_VORTEX_PORTAL_WS;
                const res = await fetch(`${baseUrl}/customers/${this.customerGUID}/campaign/list`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                });
                const data = await res.json();
                if (data.success && Array.isArray(data.campaigns)) {
                    this.campaigns = data.campaigns.map(c => ({
                        id: c.campaignID,
                        name: c.campaignName,
                        status: c.status?.campaignStatus,
                        botName: c.botDisplayName || c.defaultBotDisplayName || 'N/A',
                        startDate: c.schedulerSettings?.beginningDate,
                        endDate: c.schedulerSettings?.endingDate,

                    }));
                } else {
                    console.error("Invalid campaigns data:", data);
                }
            } catch (err) {
                console.error("Error fetching campaigns:", err);
            }
        },
        formatDate(date) {
            if (!date) return '';
            return new Date(date).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        },
        getStatusClass(status) {
            if (status === 'Completed') {
                return 'status-completed';
            }
            if (status === 'In-progress') {
                return 'status-in-progress';
            }
            if (status === 'Not-started') {
                return 'status-not-started';
            }
            if (status === 'Locked') {
                return 'status-locked';
            }
            return '';
        },
        toggleMenu(campaignId) {
            if (this.showMenu === campaignId) {
                this.showMenu = null;
            } else {
                this.showMenu = campaignId;
            }
        },
        closeMenu() {
            this.showMenu = null;
        },
        async dismissCampaignSuccessPopup() {
            this.showCampaignSuccessPopup = false;
            const query = { ...this.$route.query };
            delete query.campaignCreated;

            try {
                await this.$router.replace({ path: this.$route.path, query });
            } catch (error) {
                console.error('Unable to clear campaign success notice from the URL:', error);
            }
        },
        editCampaign(campaignId, campaignName) {
            localStorage.setItem('campaignName', campaignName);
            this.$router.push({ path: '/partner/campaign-details', query: { campaignid: campaignId } });
        },
        async deleteCampaign(campaignId) {
            const campaignToDelete = this.campaigns.find(c => c.id === campaignId);
            if (campaignToDelete && campaignToDelete.status === 'In-progress') {
                alert("You can't delete a processing campaign.");
                return;
            }

            if (confirm('Are you sure you want to delete this campaign?')) {
                try {
                    const baseUrl = process.env.VUE_APP_VORTEX_PORTAL_WS;
                    await fetch(`${baseUrl}/customers/${this.customerGUID}/campaign/${campaignId}`, {
                        method: 'DELETE',
                    });
                    this.fetchCampaigns();
                } catch (err) {
                    console.error("Error deleting campaign:", err);
                }
            }
        }
    }
}
</script>


<style scoped>
.campaign-success-overlay {
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(65, 70, 74, 0.35);
}

.campaign-success-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: min(440px, 100%);
    padding: 16px 18px 14px;
    border: 1px solid #1b7f4d;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
    text-align: center;
}

.campaign-success-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #1b7f4d;
    color: #fff;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
}

.campaign-success-popup h2 {
    color: #111827;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: -0.02em;
}

.campaign-success-popup h2,
.campaign-success-popup p {
    margin: 0;
}

.campaign-success-popup p {
    color: #111827;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: -0.02em;
}

.campaign-success-popup button {
    width: 100%;
    max-width: 220px;
    height: 42px;
    border: 0;
    border-radius: 8px;
    background: #e45f2b;
    color: #fff;
    font: inherit;
    font-size: 18px;
    font-weight: 800;
    cursor: pointer;
}

.state-dropdown-container {
    padding: 0 20px 20px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.state-dropdown-container label {
    font-weight: 500;
}

.state-dropdown-container select {
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.title-btn {
    background-color: #E45F2B;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    padding: 10px 25px;
    font-size: 14px;
    transition: background-color 0.2s ease-in-out;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
}

.title-btn:hover {
    background-color: #000000;
}

.campaign-table {
    width: 100%;
    border-collapse: collapse;
}

.campaign-table th,
.campaign-table td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    font-size: 14px;

}

.campaign-link {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 4px;
    transition: all 0.2s ease-in-out;
}

.campaign-link:hover {
    background-color: #f1f1f1;
    text-decoration: none;
    color: #E45F2B
}

.campaign-table th {
    background-color: #333c49;
    font-weight: 600;
    color: white;
}

.actions-header {
    text-align: right;
}

.status-dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
}

.status-completed {
    background-color: #28a745;

}

.status-in-progress {
    background-color: #ffc107;

}

.status-not-started {
    background-color: #6c757d;

}

.status-locked {
    background-color: #dc3545;

}

.actions-cell {
    text-align: right;
}

.action-btn {
    background-color: #E45F2B;
    color: white;
    border: none;
    cursor: pointer;
    padding: 5px 15px;
    margin: 0 5px;
    font-size: 14px;
    font-weight: bold;
    border-radius: 18px;
    transition: background-color 0.2s ease-in-out;
}

.action-btn:hover {
    background-color: #000000;
}

.action-menu-container {
    position: relative;
    display: inline-block;
}

.action-menu {
    display: block;
    position: absolute;
    top: 100%;
    background-color: white;
    min-width: 75px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    z-index: 1;
    right: 0;
    margin-top: 5px;
    border-radius: 4px;
    border: 1px solid #ddd;
    padding: 4px 0;
}

.action-menu-item {
    color: black;
    padding: 6px 12px;
    text-decoration: none;
    display: block;
    width: 80%;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 13px;
}

.action-menu-item:hover {
    background-color: #f1f1f1;
}

.action-menu-item.edit {
    color: #1976D2;

}

.action-menu-item.delete {
    color: #D32F2F;

}

.action-menu-item.delete:disabled {
    color: #9e9e9e;
    cursor: not-allowed;
    opacity: 0.5;
}

.action-menu-item.delete:disabled:hover {
    background-color: transparent;
}

.pagination-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.text-caption {
    font-size: 12px;
    color: #555;
}

</style>
